module.exports = __webpack_public_path__ + "media/images/v2/Kwivrr_Provider_logo-2095fb31844e3a596cc75790d11bb097.png";